import { render, staticRenderFns } from "./VTextarea.vue?vue&type=template&id=240f42bc"
import script from "./VTextarea.vue?vue&type=script&lang=js"
export * from "./VTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports